var _g, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGauge(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_4",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 99.21 99.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M98.1,72.08h-19.91c-.55,0-1-.45-1-1,0-15.15-12.33-27.48-27.48-27.48s-27.48,12.33-27.48,27.48c0,.55-.45,1-1,1H1.31c-.55,0-1-.45-1-1C.31,43.85,22.47,21.69,49.71,21.69s49.39,22.16,49.39,49.39c0,.55-.45,1-1,1ZM79.17,70.08h17.92c-.53-25.67-21.58-46.39-47.38-46.39S2.86,44.41,2.32,70.08h17.92c.53-15.79,13.54-28.48,29.46-28.48s28.93,12.69,29.46,28.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.4,46.4c-.35,0-.68-.18-.87-.5l-9.97-17.27c-.28-.48-.11-1.09.37-1.37.48-.28,1.09-.11,1.37.37l9.97,17.27c.28.48.11,1.09-.37,1.37-.16.09-.33.13-.5.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M62.02,46.4c-.17,0-.34-.04-.5-.13-.48-.28-.64-.89-.37-1.37l9.97-17.27c.28-.48.89-.64,1.37-.37.48.28.64.89.37,1.37l-9.97,17.27c-.19.32-.52.5-.87.5Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.71,75.98c-3.56,0-6.45-2.89-6.45-6.45s2.89-6.45,6.45-6.45,6.45,2.89,6.45,6.45-2.89,6.45-6.45,6.45ZM49.71,65.08c-2.45,0-4.45,2-4.45,4.45s2,4.45,4.45,4.45,4.45-2,4.45-4.45-2-4.45-4.45-4.45Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.71,65.08c-.55,0-1-.45-1-1V28.84c0-.55.45-1,1-1s1,.45,1,1v35.25c0,.55-.45,1-1,1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.71,78.89c-.55,0-1-.45-1-1v-2.91c0-.55.45-1,1-1s1,.45,1,1v2.91c0,.55-.45,1-1,1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGauge);
export default __webpack_public_path__ + "static/media/Gauge.5cc784f72c755895cba18dc031e72c5c.svg";
export { ForwardRef as ReactComponent };